module.exports = __webpack_public_path__ + "img/19197826-[Converted].9b673d18.png";